import { render, staticRenderFns } from "./2ede17a4-6a5a-4a69-94e0-60d0a2c1634d.vue?vue&type=template&id=0ef053a2&scoped=true"
import script from "./2ede17a4-6a5a-4a69-94e0-60d0a2c1634d.vue?vue&type=script&lang=ts"
export * from "./2ede17a4-6a5a-4a69-94e0-60d0a2c1634d.vue?vue&type=script&lang=ts"
import style0 from "./2ede17a4-6a5a-4a69-94e0-60d0a2c1634d.vue?vue&type=style&index=0&id=0ef053a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef053a2",
  null
  
)

export default component.exports